let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("dUXgJ"), load("8RcKV")]).then(() => parcelRequire('4JAbX'));